import {BaseService} from '../baseService.js';

/* 
 * Handles interaction with the customer applications api
 */
export class CustomerApplicationService extends BaseService {

	constructor() {	
		super();
	}
	
	async getApplications(paging) {
		var params = '';
		if (paging) {
			params = '?' + this.toQueryParam(paging);
		}		
		var data = await this.makeGETRequest('/api/resource/customer-applications' + params);		
		return data;		
	}
	
	async getApplication(applicationId) {
		var data = await this.makeGETRequest('/api/resource/customer-applications/' + applicationId);		
		return data;		
	}
	
	async getEFSCarrier(carrierId) {
		var data = await this.makeGETRequest('/api/resource/customer-applications/efscarrier/' + carrierId);		
		return data;		
	}	
	
	async getApplicationDetails(applicationId) {
		var data = await this.makeGETRequest('/api/resource/customer-applications/' + applicationId + '/details');		
		return data;		
	}
	
	async saveApplication(application) {
		var saved = await this.makePOSTRequest('/api/resource/customer-applications', application);
		return saved;		
	}

	
}